import React from "react"

// Components
import "./style.css"

const Button = ({ children, size, onClick, center, color }) => {
    return (
        <button onClick={onClick} className={`
          button
          button--${size}
          ${center ? "button--center" : ""}
          ${color ? color : ""}
          ${!onClick ? "button--disabled" : ""}
          `}>
            { children }
        </button>
    )
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button/index.js